export default Object.freeze({
  InProgress: 'in-progress',
  Completed: 'completed',
  CompletedWithWarning: 'completed-with-warning',
  AllFailed: 'all-failed',
  Aborted: 'aborted',
  Error: 'error',
});
